/* CUSTOM [MTO]: Enforce ready-to-ship stock limits in the cart page and drawer. */
(function () {
  /* CUSTOM [MTO]: Helpers */

  function getQuantityInput(line) {
    return line.querySelector(
      'input.quantity__input, input[name="updates[]"]'
    );
  }


  function getReadyInventory(line) {
    return Math.max(
      0,
      parseInt(
        line.dataset.readyInventory || '0',
        10
      ) || 0
    );
  }


  function isReadyMtoLine(line) {
    return (
      line &&
      line.dataset.lineType === 'ready' &&
      line.dataset.mtoEligible === 'true'
    );
  }

  function getTotalReadyQuantity(
    line
  ) {

    if (!line) {
      return 0;
    }


    const variantId =
      String(
        line.dataset.variantId || ''
      );


    if (!variantId) {
      return 0;
    }


    /*
     * Cart page and cart drawer may both exist
     * in the DOM.
     *
     * Only count lines inside the same cart.
     */
    const cartScope =
      line.closest(
        'cart-items, cart-drawer-items'
      );


    if (!cartScope) {
      return 0;
    }


    let totalReadyQuantity = 0;


    cartScope
      .querySelectorAll(
        `[data-mto-cart-line][data-variant-id="${CSS.escape(variantId)}"]`
      )
      .forEach(
        (variantLine) => {

          /*
           * Only Ready-to-Ship lines consume
           * physical inventory.
           *
           * Made-to-Order lines do not.
           */
          if (
            !isReadyMtoLine(
              variantLine
            )
          ) {
            return;
          }


          const input =
            getQuantityInput(
              variantLine
            );


          totalReadyQuantity +=
            Math.max(
              0,
              parseInt(
                input?.value || '0',
                10
              ) || 0
            );
        }
      );


    return totalReadyQuantity;
  }

  function isGiftWrapLine(line) {
    return (
      line &&
      line.dataset.isGiftWrap === 'true'
    );
  }


  function getGiftWrapId(line) {
    return String(
      line?.dataset.giftWrapId || ''
    );
  }


  function getGiftFor(line) {
    return String(
      line?.dataset.giftFor || ''
    );
  }


  function getLineQuantity(line) {

    const input =
      getQuantityInput(line);

    return Math.max(
      0,
      parseInt(
        input?.value || '0',
        10
      ) || 0
    );
  }

  /* CUSTOM [MTO]: Ready-stock limit message */

  function showReadyLimitMessage(
    line,
    readyInventory
  ) {
    const message =
      line.querySelector(
        '[data-ready-limit-message]'
      );

    if (!message) {
      return;
    }

    message.textContent =
      `Only ${readyInventory} ready-to-ship ` +
      `${readyInventory === 1 ? 'piece is' : 'pieces are'} available. ` +
      `Additional quantities are available as ${line.dataset.mtoLabel}.`;

    message.hidden = false;
  }


  function hideReadyLimitMessage(
    line
  ) {
    const message =
      line.querySelector(
        '[data-ready-limit-message]'
      );


    if (message) {
      message.hidden = true;
    }
  }


  /*
   * ======================================================
   * PLUS BUTTON
   * ======================================================
   *
   * Example:
   *
   * Physical stock = 3
   *
   * Ready to Ship = 1
   * Press + → 2
   *
   * Ready to Ship = 2
   * Press + → 3
   *
   * Ready to Ship = 3
   * Press + →
   *
   * Ready stays 3.
   * Nothing is added to Made to Order.
   * Customer sees a stock-limit message.
   */

  document.addEventListener(
    'click',

    function (event) {
      const plusButton =
        event.target.closest(
          'quantity-input button[name="plus"]'
        );


      if (!plusButton) {
        return;
      }


      const line =
        plusButton.closest(
          '[data-mto-cart-line]'
        );


      if (!isReadyMtoLine(line)) {
        return;
      }


      const input =
        getQuantityInput(line);


      if (!input) {
        return;
      }


      const readyInventory =
        getReadyInventory(line);


      const totalReadyQuantity =
        getTotalReadyQuantity(
          line
        );


      /*
       * Still below available physical stock
       * across ALL Ready-to-Ship cart lines
       * for this variant.
       *
       * Let Shopify Studio handle the + button normally.
       */
      if (
        totalReadyQuantity <
        readyInventory
      ) {
        hideReadyLimitMessage(
          line
        );

        return;
      }


      /*
       * Ready-to-Ship stock has reached its limit.
       *
       * Stop Shopify's native quantity component BEFORE
       * it increments the quantity.
       */
      event.preventDefault();

      event.stopImmediatePropagation();



      /*
       * Tell the customer why they cannot add more.
       */
      showReadyLimitMessage(
        line,
        readyInventory
      );
    },

    /*
     * Capture phase is important.
     *
     * Shopify's quantity-input JavaScript also listens
     * for clicks. This allows our code to run first.
     */
    true
  );


  /*
   * ======================================================
   * MANUAL QUANTITY ENTRY
   * ======================================================
   *
   * Customers may type directly into the quantity field.
   *
   * Example:
   *
   * Stock = 3
   * Customer types 5
   *
   * We change the field back to 3
   * and show the Ready-to-Ship stock message.
   *
   * We DO NOT create Made-to-Order items.
   */

  document.addEventListener(
    'change',

    function (event) {
      const input =
        event.target.closest(
          'input.quantity__input, input[name="updates[]"]'
        );


      if (!input) {
        return;
      }


      const line =
        input.closest(
          '[data-mto-cart-line]'
        );


      if (!isReadyMtoLine(line)) {
        return;
      }


      const readyInventory =
        getReadyInventory(line);


      const requestedQuantity =
        Math.max(
          0,
          parseInt(
            input.value || '0',
            10
          ) || 0
        );

      const totalReadyQuantity =
        getTotalReadyQuantity(
          line
        );

      /*
       * Quantity is valid.
       *
       * Let Studio's native cart JavaScript handle it.
       */
      if (
        totalReadyQuantity <=
        readyInventory
      ) {
        if (
          input.dataset.preserveReadyLimitMessage ===
          'true'
        ) {
          delete input.dataset.preserveReadyLimitMessage;

          return;
        }


        hideReadyLimitMessage(
          line
        );

        return;
      }


      /*
       * Requested quantity exceeds Ready-to-Ship stock.
       *
       * Prevent Studio from submitting the invalid amount.
       */
      event.preventDefault();

      event.stopImmediatePropagation();


      /*
       * Determine how much Ready-to-Ship inventory
       * is already being used by OTHER cart lines
       * of this same variant.
       */
      const otherReadyQuantity =
        totalReadyQuantity -
        requestedQuantity;


      const allowedQuantity =
        Math.max(
          0,
          readyInventory -
            otherReadyQuantity
        );


      /*
       * Restore the maximum valid quantity for
       * THIS Ready-to-Ship line.
       */
      input.value =
        allowedQuantity;


      showReadyLimitMessage(
        line,
        readyInventory
      );


      /*
       * Preserve the warning through the valid
       * synthetic change event below.
       */
      input.dataset.preserveReadyLimitMessage =
        'true';

      /*
       * Dispatch a NEW valid change event.
       *
       * On this second event:
       *
       * requestedQuantity === readyInventory
       *
       * so this script allows the event through and
       * Shopify's native cart code can save the capped
       * quantity normally.
       */
      input.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    },

    true
  );


  /*
   * ======================================================
   * MINUS BUTTON
   * ======================================================
   *
   * If customer decreases the Ready-to-Ship quantity,
   * remove the stock-limit warning.
   *
   * Shopify still handles the actual quantity change.
   */

  document.addEventListener(
    'click',

    function (event) {
      const minusButton =
        event.target.closest(
          'quantity-input button[name="minus"]'
        );


      if (!minusButton) {
        return;
      }


      const line =
        minusButton.closest(
          '[data-mto-cart-line]'
        );


      if (!isReadyMtoLine(line)) {
        return;
      }


      hideReadyLimitMessage(
        line
      );
    },

    true
  );


  /*
   * ======================================================
   * OPTIONAL INITIAL STATE
   * ======================================================
   *
   * If a Ready-to-Ship line is already at its maximum
   * when the cart loads, we leave the + button visible.
   *
   * Pressing it shows the explanatory message.
   *
   * We intentionally do NOT disable or hide the button,
   * because allowing the customer to press it gives us
   * an opportunity to explain why they cannot add more.
   */

})();